import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";

import "./sentry/config";

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
